import { IconDefinition, Library } from "@fortawesome/fontawesome-svg-core";
interface ErrorMessageFn<Type> {
  (error: Type) : string
}
function errorMessage<Type extends Object>(error: Type): string {
  return error.toString();
}
export let getErrorMessage: ErrorMessageFn<Error> = errorMessage;

export const addFontAwesomeIcons = (iconList: IconDefinition[], library: Library) => {
  let count = 0;
  iconList.forEach(i => {
    library.add(i);
    count++;
  });
  return count;
}